import { render, staticRenderFns } from "./enemyDeathChart.vue?vue&type=template&id=24cd1698"
import script from "./enemyDeathChart.vue?vue&type=script&lang=js"
export * from "./enemyDeathChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports